module.exports = Backbone.Model.extend({
    categoryItem: null,
});
